<app-drr-ccd-data-context class="process-details-container">
  <div class="page-padding">
    <app-application-header
      class="page-padding"
      [title]="'installation-data.ccd-drr' | translate"
      [applicationExternalId]="(DrrCcdDataStore.getApplicationDto() | async)?.application_ext_id"></app-application-header>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <app-technical-data #technicalData [applicationId]="applicationId" [isDetailsView]="true"></app-technical-data>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <app-personal-data-form
      #personalData
      [applicationId]="applicationId"
      [isDetailsView]="true"
      [showStepsWidget]="false"
      [showOrderHistory]="false"
      [showButtons]="false"
      [showPageHeader]="false"></app-personal-data-form>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <app-ccd-drr-documents-form #documents [isDetailsView]="true"></app-ccd-drr-documents-form>
  </div>

  <div class="page-padding">
    <app-order-process
      #orderProcess
      (onOrderProcessUpdated)="getOrderProcess()"
      (updateApplication)="saveChanges($event)"></app-order-process>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <app-order-history *ngIf="true" [applicationId]="applicationId" [pagination]="true" class="order-history"></app-order-history>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 text-right-align action-buttons-section">
    <button class="action-button" label="Download" pButton (click)="downloadAllDocuments()"></button>
    <button class="action-button" label="Print" pButton (click)="print()"></button>
  </div>
</app-drr-ccd-data-context>
<app-loader *ngIf="loading"></app-loader>
